import React from "react";
import LoginContainer from "../components/login/LoginContainer";

function Login() {
  return <LoginContainer />;
}

export default Login;
